import * as React from "react";
import { useContext, useEffect, useState } from "react";

import { useAuth } from "../../../contexts/AuthContext.jsx";
import { alertV2 } from "../../../api/index.js";

import InfoDialog from "./InfoDialog.jsx";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
function ProceedInspection({
  openModal,
  setOpenModal,
  onSuccess,
  actionTaken,
  data,
  alertId,
}) {
  const [open, setOpen] = React.useState(false);
  const [textValue, setTextValue] = React.useState("");
  const handleChangeValue = (e) => {
    setTextValue(e.target.value);
  };
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
  };
  const { email } = useAuth();
  const submitHandler = async () => {
    const payload = {
      email: email,
      event_details: `Has responded to the alarm to ${actionTaken}. `,
      event_name: "Response",
      event_action: actionTaken,
      alert_id: alertId,
      action_detail: JSON.stringify({
        action_completed: ``,
        action_name: actionTaken,
        confirmed_issue: "",
        action_work: ``,
        additional_comment: textValue,
      }),
    };

    const res = await alertV2.addLogAction(alertId, payload, null);
    onSuccess();
    setOpenModal(false);
    setTextValue("");
    setOpen(false);
  };
  useEffect(() => {
    if (data) {
      setTextValue(data.additional_comment);
    } else {
      setTextValue("");
    }
  }, [data]);
  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  return (
    <div>
      <Modal show={open} size={"lg"} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert Response - Proceed with Inspection</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              fontSize: "13px",
              position: "relative",
              padding: "20px",
            }}
          >
            <div>
              Please let us know why you decided to proceed with the inspection
              of the machine. We recommend providing additional context. This
              will help us in providing better recommendations in the future.{" "}
              <sup>*</sup>
            </div>
            <div style={{ padding: "5px 15px", position: "relative" }}>
              <textarea
                value={textValue}
                disabled={!!data}
                placeholder="Please share more details here."
                onChange={handleChangeValue}
                cols="30"
                rows="4"
                style={{
                  width: "100%",
                  resize: "none",
                  padding: "10px",
                  fontFamily: '"Source Sans Pro", sans-serif',
                  fontSize: "13px",
                }}
              ></textarea>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="theme" onClick={submitHandler}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default ProceedInspection;
